import axios from "axios";
import config from "../config";
import { FormResponse } from "./ResponseModels/FormResponse";

export async function PostFollowModel(workorderUiid: string, action: string) {
  let response = null;
  response = axios
    .post<FormResponse>(config.getFollowingEndpoint, {
      workorderUiid: workorderUiid,
      action: action,
    })
    .catch((e) => {
      console.error("There was an error!", e);
    });

  return response;
}
